import { registerErrorMessages } from "@getaways/extranet-ui";
import "@getaways/extranet-ui/styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./reports.css";

registerErrorMessages({ forbidden: "Your role does not give access to this." });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
